import { t } from 'i18next';
import * as yup from 'yup';

export const requirementsSchema = yup.object().shape({
  details: yup.string().nullable().label(t('labelRequirements')),
});
